import { createSelector } from '@reduxjs/toolkit'

const getStateProductListDownload = state => state.products.download

export const getProductListDownload = createSelector(
  [getStateProductListDownload],
  product => product
)
